import type { AccountInfo } from '@azure/msal-browser'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { apiTokenRequest } from '@/authConfig'
import { msalInstance, msalTracking } from '@/msalInstance'

export const getAccessToken = async (): Promise<string | null> => {
  await msalTracking.initializingPromise
  let account: AccountInfo | null = null
  try {
    account = msalInstance.getAllAccounts()[0]
  } catch (ex) {
    // eslint-disable-next-line no-console
    console.error(ex)
  }
  if (!account) return null

  const accessTokenRequest = { ...apiTokenRequest, account }
  let accessTokenResponse
  try {
    accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest)
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError)
      accessTokenResponse = await msalInstance.acquireTokenPopup(accessTokenRequest)
  }

  return accessTokenResponse?.accessToken ?? null
}

const apiQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  WebApi,
  extraOptions
) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: async headers => {
      const accessToken = await getAccessToken()

      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`)
      }

      return headers
    }
  })

  return baseQuery(args, WebApi, extraOptions)
}

export const apiBase = createApi({
  baseQuery: apiQuery,
  endpoints: () => ({})
})
